import { useQuery } from '@tanstack/react-query';
import { api } from 'src/services';
import { UseQueryOverrideOptions } from '../common';

export type UseGetOrganizationSettingsParams = {
  key: string;
  orgUuid: string;
};

export type UseGetOrganizationSettingsResponse<T = Record<string, any>> = {
  settings: T;
};

export const useGetOrganizationSettings = <T = Record<string, any>,>(
  params: UseGetOrganizationSettingsParams,
  options: UseQueryOverrideOptions = {}
) => {
  const { key, orgUuid } = params;
  return useQuery({
    ...options,
    queryKey: ['organizationSettings', params],
    queryFn: () =>
      api
        .get<UseGetOrganizationSettingsResponse<T>>('/organization_settings', {
          headers: {
            'Impersonate-Org-UUID': orgUuid ?? undefined,
            'Headless-Mode': true,
          },
          params: {
            key,
          },
        })
        .then((res) => res.data),
  });
};
